module.exports = __webpack_public_path__ + "img/0Q3B1666_L_Wood.62c804ec.jpg";